import { render } from "./users-create-edit.html?vue&type=template&id=4c933846&scoped=true&ts=true"
import script from "./users-create-edit.ts?vue&type=script&lang=ts"
export * from "./users-create-edit.ts?vue&type=script&lang=ts"

import "./users-create-edit.scss?vue&type=style&index=0&id=4c933846&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c933846"]])

export default __exports__